import React from 'react';
import PropTypes from 'prop-types';
import NotificationBanner from 'components/shared/NotificationBanner';

const SitewideNotification = ({ sitewideNotificationState }, { getString }) => {
  if (!sitewideNotificationState) return null;
  const message = sitewideNotificationState.notificationStringId
    ? getString(sitewideNotificationState.notificationStringId) : null;
  if (!message) return null;
  return <NotificationBanner dangerouslySetTextString={message} />;
};

SitewideNotification.propTypes = {
  sitewideNotificationState: PropTypes.shape({
    notificationStringId: PropTypes.string,
  }),
};

SitewideNotification.contextTypes = {
  getString: PropTypes.func.isRequired,
};

export default SitewideNotification;
